<template>
  <div class="mainContent">
    <div class="morning">
      <div class="title">
        <span class="userCenter" @click="toUserCenter"
          >{{ text }}, {{ username }}</span
        >
      </div>
      <div class="login_infor">最近登录：{{ recentLoginTime }}</div>
      <div class="detail_list">
        <div class="details info" @click="toInfo">
          <div class="icon_img icon">
            <img :src="imgUrl" alt />
          </div>
          <div class="icon_img">
            <span class="second_title" @click="ifrme">消息中心</span>
            <span
              :class="{
                second_infor: count === 0,
                'second_infor red': count > 0,
              }"
            >
              <span
                :class="{
                  number_of_messages: count === 0,
                  'number_of_messages red': count > 0,
                }"
                >{{ count }}</span
              >
              条未读消息
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="features">
      <div class="title">
        <span class="line"></span>
        <span class="txt">功能介绍</span>
      </div>
      <div class="detail_list">
        <div class="details" v-for="(item, index) of FeaturesData" :key="index">
          <div class="icon_img icon">
            <img :src="item.img_url" alt />
          </div>
          <div
            class="icon_img titles"
            @click="
              routerLink(
                item.second_infor.filter(
                  (jtem) =>
                    jtem.url.includes('QuaReport') ||
                    jtem.url.includes('FundAgency')
                )[0].url
              )
            "
          >
            <div class="mytitles">{{ item.second_title }}</div>
            <!-- <div class="second_infors">
              <span
                class="second_infor"
                v-for="(itemLink, linkI) of item.second_infor"
                :key="linkI"
                @click="routerLink(itemLink.url)"
                >{{ itemLink.info }}</span
              >
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import imgUrl from "@/assets/images/menuIcon/icon2@2x.png";
import { userDetail, getNoticeCount, getReportList } from "common/js/api";

export default {
  data() {
    return {
      text: "",
      username: "",
      imgUrl,
      loginTime: "最近登录：2019年6月13日 16:00",
      count: 0,

      FeaturesData: [
        {
          img_url: require("../../assets/images/menuIcon/icon3@2x.png"),
          second_title: "机构入驻申请",
          second_infor: [
            {
              info: "入驻基金管理机构 · ",
              url: "/FundManagement/FundList",
            },
            {
              info: "入驻基金机构",
              url: "/FundAgency/FundList",
            },
          ],
        },
        {
          img_url: require("../../assets/images/menuIcon/icon5@2x.png"),
          second_title: "入驻进度查询",
          second_infor: [
            {
              info: "入驻基金管理机构 · ",
              url: "/Audit/List",
            },
            {
              info: "入驻基金机构",
              url: "/Audit/List",
            },
          ],
        },
        {
          img_url: require("../../assets/images/menuIcon/icon4@2x.png"),
          second_title: "企业季报填报",
          second_infor: [
            {
              info: "下次填报季报时间：",
              url: "/QuaReport/Record",
            },
          ],
        },
      ],
      FeaturesData1: [
        {
          img_url: require("../../assets/images/menuIcon/icon3@2x.png"),
          second_title: "机构入驻申请",
          second_infor: [
            {
              info: "入驻基金机构",
              url: "/FundAgency/FundList",
            },
          ],
        },
        {
          img_url: require("../../assets/images/menuIcon/icon5@2x.png"),
          second_title: "入驻进度查询",
          second_infor: [
            {
              info: "入驻基金机构",
              url: "/Audit/List",
            },
          ],
        },
        {
          img_url: require("../../assets/images/menuIcon/icon4@2x.png"),
          second_title: "企业季报填报",
          second_infor: [
            {
              info: "下次填报季报时间：",
              url: "/QuaReport/Record",
            },
          ],
        },
      ],
      userCode: "",
      recentLoginTime: "",
    };
  },

  created() {
    // this.userCode = "JG764559";
    // 获取当前时间
    let timeNow = new Date();
    //获取当前小时
    let hours = timeNow.getHours();
    //判断当前时间段
    if (hours >= 0 && hours <= 10) {
      this.text = "早上好";
    } else if (hours > 10 && hours <= 14) {
      this.text = "中午好";
    } else if (hours > 14 && hours <= 18) {
      this.text = "下午好";
    } else if (hours > 18 && hours <= 24) {
      this.text = "晚上好";
    }
    this.userCode = this.Cookies.get("identifyCode");
    this.username = this.Cookies.get("legalName");
    this.recentLoginTime = this.Cookies.get("lastTime");
    const date = this.setNextTime();
    this.FeaturesData[2].second_infor[0].info = `下次填报季报时间：${date}`;
  },

  mounted() {
    this.getUserDetail();
    this.getNoticeCount();
    if (this.$route.query.first && this.$route.query.first == 1) {
      console.log("第一次进入");
      const myDate = new Date();
      // this.firstLogin();
      if (
        myDate.getMonth() == 1 ||
        myDate.getMonth() == 4 ||
        myDate.getMonth() == 7 ||
        myDate.getMonth() == 10
      ) {
        if (myDate.getDate() >= 1 && myDate.getDate() <= 15) {
          this.firstLogin();
        }
      }
    }
  },

  methods: {
    async firstLogin() {
      const params = {
        identifyCode: this.userCode,
        page: 1,
        size: 255,
      };
      const { result } = await getReportList(params);
      let _is = false;
      console.log("进入弹窗方法");
      if (result && result.list && result.list.length > 0) {
        for (let index = 0; index < result.list.length; index++) {
          const element = result.list[index];
          if (element.status != 2) {
            _is = true;
            console.log("触发弹窗");
            break;
          } else {
            console.log("不触发弹窗");
          }
        }
      } else {
        console.log("未成功获取到数据");
      }
      if (_is == true) {
        this.showWindow();
      }
    },
    showWindow() {
      console.log("弹窗");
      const title = "欢迎使用湘江私募基金管理服务平台";
      const container = "您有未填写的季报请";
      const link = "/#/QuaReport/Record";
      const cssStyle =
        "#mywindow,#mywindow * {box-sizing: border-box;} #mywindow { background-color:#fff;border: 1px solid #ccc;width: 400px;height: 200px;position: fixed;bottom: -400px;right: 10px;border-radius: 6px;box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);z-index: 999;transition: bottom 2s;} #mywindow #mywindow-title {height: 30px;width: 100%;padding: 8px;font-size: 12px;line-height: 14px;font-weight: 600; } #mywindow #mywindow-body {height: calc(100% - 30px);width: 100%;padding: 8px;display: flex;align-items: center;justify-content: center;} #mywindow a {color: #409eff !important;text-decoration:underline !important;} #mywindow a:hover {color: #551a8b !important;}";
      const htmlInner = `<div id="mywindow"><div id="mywindow-title">${title}</div><div id="mywindow-body">${container}<a href="${link}">点击此处</a>跳转至季报管理界面</div></div>`;

      let style = document.createElement("style");
      let theHead = document.head || document.getElementsByTagName("head")[0];
      style.appendChild(document.createTextNode(cssStyle));
      theHead.appendChild(style);
      let newDiv = document.createElement("div");
      newDiv.innerHTML = htmlInner;
      let myDiv = newDiv.firstChild;
      document.body.appendChild(myDiv);
      showAndCloseDiv();
      function showAndCloseDiv() {
        setTimeout(() => {
          myDiv.style.bottom = "10px";
          setTimeout(() => {
            myDiv.style.bottom = "-400px";
            console.log(myDiv.style.bottom);
            setTimeout(() => {
              myDiv.remove();
            }, 3000);
          }, 30000);
        }, 1000);
      }
    },
    async getUserDetail() {
      const { result } = await userDetail(this.userCode);
      if (result.registedType != "GL") {
        this.FeaturesData = this.FeaturesData1;
      }
      // this.username = res.result.instition;
    },

    async getNoticeCount() {
      const { result } = await getNoticeCount(this.userCode);
      this.count = result;
    },

    toUserCenter() {
      this.$router.push("/UC/Center/UserCenter");
    },

    ifrme() {},

    toInfo() {
      this.$router.push("/UC/InfoCenter");
    },

    routerLink(path) {
      this.$router.push(path);
    },

    setQuarter(month) {
      if (month < 4) return 1;
      else if (month < 7) return 2;
      else if (month < 10) return 3;
      else return 4;
    },

    setNextTime() {
      const map = {
        1: "01",
        2: "04",
        3: "07",
        4: "10",
      };
      const season = this.setQuarter(new Date().getMonth() + 1);
      let year = new Date().getFullYear();
      let month;
      if (season < 4) {
        month = map[season + 1];
      } else {
        (month = "01"), (year += 1);
      }
      return `${year}-${month}-01~${year}-${month}-15`;
    },
  },
};
</script>
<style lang="scss" scoped>
.morning {
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
  padding: 50px 50px;
  /* margin-bottom: 40px; */
}
.title {
  width: 100%;
}
.line,
.txt {
  display: inline-block;
  vertical-align: middle;
}
.userCenter {
  cursor: pointer;
  font-size: 24px;
  font-family: AlibabaM;
  text-align: left;
  color: #191818;
}

.login_infor {
  font-size: 16px;
  margin: 12px 0;
  color: #b6bcc2;
}
.number_of_messages {
  font-size: 16px;
  color: #3165ff;
}
.second_title {
  height: 22px;
  font-size: 16px;
  font-family: Alibaba;
  text-align: left;
  color: #191818;
  margin-right: 14px;
  line-height: 22px;
}
.second_infor {
  cursor: pointer;
  font-size: 16px;
  font-family: Alibaba;
  text-align: left;
  color: #b6bcc2;
}
.second_infor:hover {
  color: blue !important;
}
.icon_img {
  display: inline-block;
  vertical-align: middle;
}

.icon {
  // width: 22px;
  // height: 22px;
  margin-right: 6px;
}
img {
  margin: auto;
  width: 20px;
}
.info {
  cursor: pointer;
}
.red {
  color: #ff2b2b !important;
}
.features {
  flex: 1;
  overflow: auto;
  margin-top: 20px;
  padding: 32px 50px 40px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
  .title {
    height: 27px;
    margin-bottom: 30px;
    .line {
      width: 4px;
      height: 20px;
      background: #008fff;
      margin-right: 10px;
    }
    .txt {
      font-size: 20px;
      font-family: AlibabaM;
      text-align: left;
      color: #191818;
      line-height: 27px;
    }
  }
  .details {
    padding: 30px 40px;
    border: 1px solid #d3d3d3;
    border-radius: 6px;
    display: flex;
    // height: 100%;
    //

    align-items: center;
    cursor: pointer;
    overflow: auto;
    .icon {
      height: 56px;
      width: 56px;
      margin-right: 14px;
    }
    .titles {
      display: flex;
      overflow: auto;
      flex-direction: column;
      // height: 100%;
      .mytitles {
        font-size: 18px;
        font-family: AlibabaM;
        text-align: left;
        color: #191818;
        line-height: 24px;
      }
      .second_title {
        font-size: 18px;
        font-family: AlibabaM;
        text-align: left;
        color: #191818;
        line-height: 25px;
      }
      .second_infors {
        flex: 1;
        overflow: auto;
        display: flex;
        overflow: auto;
        align-items: flex-end;
        .second_infor {
          font-size: 16px;
          font-family: Alibaba;
          text-align: left;
          color: #999999;
          line-height: 22px;
        }
      }
    }
    img {
      height: 56px;
      width: 56px;
    }
    &:hover {
      border-color: #008fff;
    }
  }
  .details:not(:last-child) {
    margin-bottom: 15px;
  }
}
.mainContent {
  display: flex;
  overflow: auto;
  flex-direction: column;
  height: 100%;
}
</style>
